import { render, staticRenderFns } from "./launch-sublink-simple.v2.vue?vue&type=template&id=37726cf3&"
import script from "./launch-sublink-simple.v2.vue?vue&type=script&lang=ts&"
export * from "./launch-sublink-simple.v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports